
import React from 'react'
import { WizTableForm } from '@/containers/common';

import { component_tool} from '@/tool'

let { WizDataTable} = component_tool
import { topicConfig } from './config-topic';
const columns = () => {
     return [
        {
          name: 'id',
          formItem: {
            type: 'hidden'
          }
        },
        {
          title: '账号',
          name: 'userName',
          tableItem: {
            width: 150
          }
        },
        {
          title: '姓名',
          name: 'fullName',
          tableItem: {
            width: 150
          }
        },
        {
          title: '用户昵称',
          name: 'nickName',
          tableItem: {
            width: 150
          }
        },
        {
          title: '所属话题',
          name: 'topicName',
          tableItem: {
            width: 150,
          },
        },
        {
          title: '帖子内容',
          name: 'content',
          tableItem: {
            ellipsis: true,
            width: 200
          },
          searchItem: {},
        },
        {
          title: '帖子类型',
          name: 'type',
          tableItem: { width: 100 },
          searchItem: { type: 'select' },
          dict: [
            { code: 0, codeName: '文本' },
            { code: 1, codeName: '图片' },
            { code: 2, codeName: '视频' }
          ]
        },
        {
          title: '帖子来源',
          name: 'sourceType',
          tableItem: { width: 100 },
          searchItem: { type: 'select' },
          dict: [
            { code: 0, codeName: '原创' },
            { code: 1, codeName: '转发' },
            { code: 2, codeName: '分享' }
          ]
        },
        {
          title: '所属话题',
          name: 'topicId',
          searchItem: {
            ...topicConfig,
            diy: WizTableForm,
            selectType: 'radio',
          }
        },
        {
          title: '点赞量',
          name: 'agreeCount',
          tableItem: {
            width: 100,
            render: (text, record) => (
              <WizDataTable.Oper>
                  {text}
              </WizDataTable.Oper>
            )
          }
        },
        {
          title: '点踩量',
          name: 'stepCount',
          tableItem: {
            width: 100,
            render: (text, record) => (
              <>
                
                {text}
              </>
            )
          }
        },
        {
          title: '转发量',
          name: 'transpondCount',
          tableItem: {
            width: 100,
            render: (text, record) => (
              <>
                
                {text}
              </>
            )
          }
        },
        {
          title: '评论量',
          name: 'commentCount',
          tableItem: {
            width: 100,
            render: (text, record) => (
              <>
                
                {text}
              </>
            )
          }
        },
        {
          title: '热门置顶',
          name: 'popularTop',
          tableItem: { width: 100 },
          dict: [
            { code: 0, codeName: '否' },
            { code: 1, codeName: '是' },
          ]
        },
        {
          title: '发帖时间',
          name: 'createTime',
          tableItem: { width: 200 }
        }
      ]
  }
  
  const tableApi = (api = {}) => {
    return {
      path: 'invitation/list',
      ...api
    }
  }
  
  const invitation = (self, api) => {
    return {
      type: 'diy',
      initialValue: [],
      rowkey: 'id',
      rowName: 'content',
      columns: columns(),
      tableApi: tableApi(api)
    }
  }
  
  export default invitation